import React, { useState } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseIcon from "@mui/icons-material/Close";

import {
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

const PAGES = ["Home", "Blog"];
function DrawerMenu() {
  const [toggleDrawer, setToggleDrawer] = useState(false);

  return (
    <>
      <SwipeableDrawer
        open={toggleDrawer}
        onClose={() => setToggleDrawer(false)}
        anchor="right"
      >
        <List>
          <ListItem>
            <IconButton onClick={() => setToggleDrawer(!toggleDrawer)}>
              <CloseIcon />
            </IconButton>
          </ListItem>
          {PAGES.map((page, index) => {
            return (
              <ListItem key={index}>
                <ListItemButton>
                  <ListItemIcon></ListItemIcon>
                  <ListItemText>{page}</ListItemText>
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </SwipeableDrawer>
      <IconButton onClick={() => setToggleDrawer(!toggleDrawer)}>
        <MenuRoundedIcon />
      </IconButton>
    </>
  );
}

export default DrawerMenu;
